import { Link } from "react-router-dom";
import { MapPin, ShieldCheck, MessageCircle } from "lucide-react";
import Logo from "@/components/Logo";
import { useSettings, DEFAULT_WA } from "@/context/SettingsContext";

export default function Footer() {
  const { settings } = useSettings();
  const wa = settings?.whatsapp_number || DEFAULT_WA;
  return (
    <footer className="mt-auto bg-emerald2 text-bone">
      <div className="mx-auto max-w-7xl px-4 sm:px-6 py-14 grid gap-10 md:grid-cols-3">
        <div className="space-y-4">
          <Logo dark />
          <p className="text-sm text-bone/70 max-w-xs leading-relaxed">
            Zonguldak'ın yerel 2. el pazar yeri. İlanlar moderasyon ekibimizce onaylanır, iletişim doğrudan WhatsApp ile kurulur.
          </p>
          <span className="inline-flex items-center gap-1.5 text-xs font-mono text-bone/60">
            <MapPin size={13} className="text-coral" /> ZONGULDAK / 67 — TÜM İLÇELER
          </span>
        </div>
        <div>
          <h4 className="font-display font-bold text-sm tracking-widest uppercase text-bone/50 mb-4">Yasal & Gizlilik</h4>
          <ul className="space-y-2.5 text-sm">
            <li><Link data-testid="footer-kvkk-link" to="/kvkk-aydinlatma-metni" className="hover:text-coral transition-colors">KVKK Aydınlatma Metni</Link></li>
            <li><Link data-testid="footer-terms-link" to="/kullanim-kosullari" className="hover:text-coral transition-colors">Kullanım Koşulları</Link></li>
            <li><Link data-testid="footer-cookie-link" to="/cerez-politikasi" className="hover:text-coral transition-colors">Çerez Politikası</Link></li>
          </ul>
        </div>
        <div>
          <h4 className="font-display font-bold text-sm tracking-widest uppercase text-bone/50 mb-4">İletişim</h4>
          <p className="text-sm text-bone/70 mb-4">Sorularınız için bize WhatsApp'tan ulaşın.</p>
          <a
            data-testid="footer-whatsapp-button"
            href={`https://wa.me/${wa}?text=${encodeURIComponent("Merhaba, alsat67.com hakkında bilgi almak istiyorum.")}`}
            target="_blank" rel="noopener noreferrer"
            className="inline-flex items-center gap-2 rounded-full bg-wa px-5 py-3 text-sm font-bold text-white hover:brightness-110 transition"
          >
            <MessageCircle size={17} /> WhatsApp Destek
          </a>
          <p className="mt-4 inline-flex items-center gap-1.5 text-xs text-bone/50">
            <ShieldCheck size={13} className="text-wa" /> Tüm ilanlar yayın öncesi onaydan geçer.
          </p>
        </div>
      </div>
      <div className="border-t border-bone/10">
        <div className="mx-auto max-w-7xl px-4 sm:px-6 py-5 flex flex-col sm:flex-row items-center justify-between gap-2 text-xs text-bone/50">
          <span>© {new Date().getFullYear()} alsat67.com — Zonguldak'ın 2. el pazar yeri</span>
          <span className="font-mono">67 • GÜVENLİ • YEREL</span>
        </div>
      </div>
      <div className="h-16 md:hidden" />
    </footer>
  );
}
